export default "__VITE_ASSET__DP5PkxX6__"